import { defineStore } from 'pinia';
import { OnboardingFlow, OnboardingStep } from '@/types/onboarding.types';

type OnboardingFlowState = {
  flow: OnboardingFlow;
  isActive: boolean;
  isEnabled: boolean;
  activeStep: OnboardingStep | null;
};

type OnboardingState = {
  onboardingFlowStates: OnboardingFlowState[];
};

export const useOnboardingStore = defineStore('onboarding', {
  state: (): OnboardingState => ({
    onboardingFlowStates: [],
  }),
  getters: {
    getActiveOnboardingFlow: (state) =>
      state.onboardingFlowStates.find((state) => state.isActive)?.flow,
    getOnboardingFlowActiveStep: (state) =>
      state.onboardingFlowStates.find((state) => state.isActive)?.activeStep,
    getAvailableOnboardingFlows: (state) =>
      state.onboardingFlowStates.map((state) => state.flow),
    getEnabledOnboardingFlows: (state) =>
      state.onboardingFlowStates
        .filter((state) => state.isEnabled)
        .map((state) => state.flow),
    hasEnabledOnboardingFlows: (state) =>
      state.onboardingFlowStates.some((state) => state.isEnabled),
  },
  actions: {
    addOnboardingFlow(onboardingFlow: OnboardingFlow, isEnabled: boolean) {
      this.onboardingFlowStates.push({
        flow: onboardingFlow,
        isActive: false,
        isEnabled: isEnabled,
        activeStep: null,
      });
    },
    setActiveOnboardingFlow(onboardingFlow: OnboardingFlow) {
      for (const flowState of this.onboardingFlowStates) {
        flowState.isActive =
          onboardingFlow && flowState.flow.key === onboardingFlow.key;
      }
    },
    setActiveOnboardingFlowStep(onboardingFlowStep: OnboardingStep) {
      this.onboardingFlowStates.find((state) => state.isActive)!!.activeStep =
        onboardingFlowStep;
    },
    resetActiveOnboardingFlow() {
      for (const flowState of this.onboardingFlowStates) {
        flowState.isActive = false;
        flowState.activeStep = null;
      }
    },
  },
});
